// extracted by mini-css-extract-plugin
module.exports = {"Control":"css-modules_Control__LSWaC","Track":"css-modules_Track__1KzC2","Indicator":"css-modules_Indicator__OIuvs","Thumb":"css-modules_Thumb__E9uJe"};